<template>
    <transition name="modal">
        <div class="modal-mask"
             @click="close">
            <div class="modal-container" @click.stop>
                <div class="modal-header">
                    <div class="modal-info">
                        {{ setModalTitle(type) }}
                    </div>
                </div>

                <div class="modal-body">

                    <div v-if="type == 'random'">

                        <button v-for="number in gameSvc.spotNumber"
                                v-if="isValid(number)"
                                :key="number"
                                class="modal-btn"
                                :class="{is__active : activeRandom === number}"
                                @click="selectRandom(number)">
                                {{ setRandomLabel(number) }}
                        </button>

                    </div>

                    <div v-else-if="type == 'system' && bettingSvc.ticket.input.length">

                        <button v-for="number in (bettingSvc.ticket.input.length <= gameSvc.spotNumber && bettingSvc.ticket.input.length  ? ( bettingSvc.ticket.input.length - 1 ) : gameSvc.spotNumber)"
                                v-if="isValid(number, bettingSvc.ticket.input.length)"
                                :key="number"
                                class="modal-btn"
                                :class="{is__active : activeSystem === number}"
                                @click="selectSystem(number)">
                                {{ setSystemLabel(number, bettingSvc.ticket.input.length) }}
                        </button>

                    </div>
                </div>

                <div class="modal-footer text-center">
                    <button class="btn save-btn"
                    @click="save">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { isNil } from 'lodash';
import { EventBus } from "../../utilities/event.bus";
import { GameSvc } from "../../services/game.service";
import { BettingSvc } from "../../services/betting.service";
import { PaytableSvc } from '../../services/paytable.service'
import { TranslationSvc } from '../../services/translation.service';
import { capitalize } from "../../filters/capitalize";

export default {
  name: "Modal",
  props: ["type"],
  filters: {
    capitalize: capitalize
  },
  data() {
    return {
      gameSvc: GameSvc.getGameSvc(),
      bettingSvc: BettingSvc.getBettingSvc(),
      paytableSvc : PaytableSvc.getPaytableSvc(),
      activeRandom: null,
      activeSystem: null
    };
  },
  methods: {
    close() {
      EventBus.$emit("Modal.Close");
      this.activeSystem = null;
    },
    isValid(number1, number2) {
      let n1 = number1 || 1,
          n2 = number2 || n1;

      return this.paytableSvc.paytable[n1 + '_' + n2] !== undefined;
    },
    save() {
      if (this.type === "random") {
        this.bettingSvc.type = "normal";
        this.bettingSvc.clearInput();
        this.bettingSvc.clearSpecialBets();
        this.gameSvc.dactivateBalls();
        this.bettingSvc.random = this.activeRandom;
        this.bettingSvc.selectRandomNumbers();
        this.close();
        return;
      }

      if (this.activeSystem) {
        this.bettingSvc.type = "system";
        this.bettingSvc.system = this.activeSystem;
      }

      this.close();
    },

    setModalTitle(type) {
      let key = '';

      if (type === 'random') {
        key = 'random';
      } else if (type === 'system') {
        key = 'system_bet';
      }

      return TranslationSvc.getTranslation(key);
    },

    selectRandom(number) {
      this.activeRandom = number;
    },

    setRandomLabel(number = '') {
      return TranslationSvc.getTranslation('select_random') + ' ' + number;
    },

    selectSystem(number) {
      if (number) {
        this.activeSystem = number;
      }
    },

    setSystemLabel(number, total) {
      const system = !isNil(number) && !isNil(total) ? number + '/' + total : '';

      return TranslationSvc.getTranslation('select_system') + ' ' + system;
    },

  },
  mounted() {
    this.activeRandom = this.bettingSvc.random || 1;
    this.activeSystem = this.bettingSvc.system ||null;
  }
};
</script>

<style lang="scss">
@import "../../assets/style/helpers";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 300px;
  margin: 40px auto 0;
  background-color: #242424;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  margin-top: 0;
  text-transform: capitalize;
}

.modal-info {
  color: #fff;
  margin-left: 5px;
  font-size: 1.25rem;
  font-weight: bold;
}

.save-btn {
  color: #fff;
  background-color: #0066ae;
  width: 60%;
}

.modal-body {
  margin: 20px 0;

  .modal-btn {
    width: 48%;
    color: #e6e6e6;
    background-color: #424242;
    padding: 0.9rem 0.5rem;
    font-size: 1.25rem;
    line-height: 1.33;
    border: none;
    margin: 1px;
    cursor: pointer;

    &:active {
      background-color: #353535;
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.2);
      outline: none;
    }

    &:focus {
      outline: none;
    }
  }

  .is__active {
    background-color: #685834;
  }
}

.text-center {
  text-align: center;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// Modal.vue?5afcb8f7